export default function Breadcrumb() {
  return (
    <nav aria-label="面包屑" className="w-full bg-background-50 border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <ol className="flex flex-wrap items-center gap-1.5 py-3 font-label text-xs text-foreground-500">
          <li className="flex items-center gap-1.5">
            <a href="#home" className="hover:text-primary-600 cursor-pointer">
              首页
            </a>
          </li>
          <li aria-hidden="true" className="text-foreground-300">
            <i className="ri-arrow-right-s-line" />
          </li>
          <li className="flex items-center gap-1.5">
            <a href="#channels" className="hover:text-primary-600 cursor-pointer">
              频道导览
            </a>
          </li>
          <li aria-hidden="true" className="text-foreground-300">
            <i className="ri-arrow-right-s-line" />
          </li>
          <li aria-current="page" className="text-foreground-900 font-bold">
            站点地图
          </li>
        </ol>
      </div>
    </nav>
  );
}